@if ((twitterFollowers$ | async)?.length != 0) {
  @for (twitterFollower of twitterFollowers$ | async; track twitterFollower) {
    @if (twitterFollower.source !== null) {
      @if (twitterFollower.url === null || url == twitterFollower.url) {
        <app-aggregated-amount-item
          name="{{ (selectedArtist$ | async)?.nameMain }} "
          account="（ {{
            twitterFollower.userName == null ? twitterFollower.objectId : twitterFollower.userName
          }}  ）"
          icon="./assets/twitter.png"
          [amount]="twitterFollower.units"
          unit="フォロワー数"
          [rate]="twitterFollower.rate"
          [link]="twitterFollower.url"
          [hasAmount]="twitterFollower.hasUnits"
          [loading]="loading$ | async"
          help="{{
            twitterFollower.source === 'shareablee' ? 'Shareablee' : 'Chartmetric'
          }}に登録された {{
            !twitterFollower.url ? 'Twitter' : twitterFollower.url
          }} のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async"
          [dataCollectLoading]="dataCollectLoading$ | async"
          [isDecimal]="true"
        ></app-aggregated-amount-item>
      }
    } @else {
      <app-aggregated-amount-item
        name="{{ (selectedArtist$ | async)?.nameMain }}"
        icon="./assets/twitter.png"
        [amount]=""
        unit="フォロワー数"
        [rate]=""
        [link]=""
        [hasAmount]="false"
        [loading]="loading$ | async"
        help="Twitter のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
        [dataCollections]="dataCollections$ | async"
        [dataCollectLoading]="dataCollectLoading$ | async"
        ></app-aggregated-amount-item
        >
      }
    }
  } @else {
    <app-aggregated-amount-item
      name="{{ (selectedArtist$ | async)?.nameMain }}"
      icon="./assets/twitter.png"
      [amount]=""
      unit="フォロワー数"
      [rate]=""
      [link]=""
      [hasAmount]="false"
      [loading]="loading$ | async"
      help="Twitter のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
      [dataCollections]="dataCollections$ | async"
      [dataCollectLoading]="dataCollectLoading$ | async"
      ></app-aggregated-amount-item
      >
    }

